import { iterateNodes, getClosest } from './dom';

export default class Accordion {
  constructor(settings) {
    let settingSelectors = settings.selectors || [];
    let closeEvent = settings.closeEvent || false;
    let selectors = [].concat(settingSelectors);
    selectors.map(selector => {
      iterateNodes(selector, Accordion.addTransitionListener, closeEvent)
    });
  }

  static addTransitionListener(node, closeEvent) {
    node.addEventListener('click', () => Accordion.transitionMaxHeight(node));

    if (closeEvent !== false) {
      window.addEventListener(closeEvent, () => {
        Accordion.transitionMaxHeight(node);
      });
    }
  }

  static transitionMaxHeight(node) {
    let tabContent = node.parentElement.querySelector('.content');
    let textWrap = getClosest(node, '.text-wrap');
    let closeTab = tabContent.classList.contains('-open');

    this.closeOtherAccordions();
    if (closeTab) {
      if (textWrap) {
        this.updateTextWrapHeight(node, true);
      }
      return;
    }

    tabContent.classList.add('-open');
    tabContent.style.maxHeight = tabContent.scrollHeight + 'px';
    if (textWrap) {
      this.updateTextWrapHeight(node);
    }

  }

  static updateTextWrapHeight(accordionElement, close = false) {
    let textWrap = getClosest(accordionElement, '.text-wrap');
    let tabContent = accordionElement.parentElement.querySelector('.content');
    let height = tabContent.style.maxHeight.replace('px', '');
    let textWrapHeight = getComputedStyle(textWrap).height.replace('px', '');
    let newHeight = parseInt(height) + parseInt(textWrapHeight);
    let defaultTabContentHeight = textWrap.dataset.defaultVal;

    if (close) {
      newHeight = parseInt(textWrapHeight) - parseInt(height);
      if (newHeight < defaultTabContentHeight) {
        newHeight = defaultTabContentHeight;
      }
    }

    jQuery(textWrap).animate({ 'height': newHeight + 'px' });
  }


  static closeOtherAccordions() {
    iterateNodes('.accordion .content', (el) => {
      el.style.maxHeight = null;
      el.classList.remove('-open');
      el.parentNode.querySelector('input[type=checkbox]').checked = false;

      let textWrap = getClosest(el, '.text-wrap');
      if(textWrap){
        let textWrapHeight = textWrap.style.height.replace('px', '');
        let elHeight = getComputedStyle(el).height.replace('px', '');
        let newHeight = parseInt(textWrapHeight) - parseInt(elHeight);
        textWrap.style.height = newHeight + 'px';
      }
    });
  }

}